import CustomTextarea from '../Components/CustomFormElements';
import InformationPackageFeaturesTable from '../Components/InformationPackageFeaturesTable';

type ArtifactDetailsField = 'detail' | 'summary';

type UnitArtifactDetailsProps = {
  artifact: {
    key: string;
    detail: string;
    summary?: string | null;
    artifact_type: string;
    mime: string;
  };
  onChangeField: (field: ArtifactDetailsField, value: string) => void;
};

function UnitArtifactDetails({ artifact, onChangeField }: UnitArtifactDetailsProps) {
  return (
    <div className="w-100">
      <div className="input-block d-flex flex-row justify-between">
        <CustomTextarea
          id="detail"
          label="Detail"
          name="detail"
          addedText={artifact.detail}
          onChange={(value: string) => onChangeField('detail', value)}
          resizable={false}
          readOnly={true}
          height="200px"
        />
      </div>

      <div className="input-block d-flex flex-row justify-between">
        <CustomTextarea
          id="summary"
          label="Summary"
          name="summary"
          addedText={artifact.summary ?? ''}
          onChange={(value: string) => onChangeField('summary', value)}
          resizable={false}
          readOnly={true}
          height="200px"
        />
      </div>
    </div>
  );
}

export default UnitArtifactDetails;
